import { getFormattedValue } from '../../lib/capabilities/capabilities';

import { useI18n } from '../../hooks/useI18nFormatters';
import { useCapabilityValue } from '../../store/devices/useCapabilityValue';

import styles from './IndicatorString.module.css';

export function IndicatorString(props) {
  const { i18n } = useI18n();
  const [value, , capabilityObj] = useCapabilityValue({
    deviceId: props.device.id,
    capabilityId: props.capabilityId,
  });

  let text = value;

  if (capabilityObj?.type === 'enum') {
    if (value == null) {
      return null;
    }

    const selectedOption = capabilityObj.values?.find((option) => {
      return option.id === value;
    });

    text = selectedOption?.title ?? String(value);
  }

  if (capabilityObj?.type === 'boolean') {
    if (value == null) {
      return null;
    }

    text = getFormattedValue({ messageFormatter: i18n.messageFormatter, capabilityObj, value });
  }

  return (
    <div className={styles.root} title={typeof text === 'string' ? text : undefined}>
      {text}
    </div>
  );
}
